var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21745 0.833984C8.58564 0.833984 8.88411 1.13246 8.88411 1.50065V3.16732C8.88411 3.53551 8.58564 3.83398 8.21745 3.83398C7.84926 3.83398 7.55078 3.53551 7.55078 3.16732V1.50065C7.55078 1.13246 7.84926 0.833984 8.21745 0.833984Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21745 11.334C8.58564 11.334 8.88411 11.6325 8.88411 12.0007V14.6673C8.88411 15.0355 8.58564 15.334 8.21745 15.334C7.84926 15.334 7.55078 15.0355 7.55078 14.6673V12.0007C7.55078 11.6325 7.84926 11.334 8.21745 11.334Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05078 8.00065C1.05078 7.63246 1.34926 7.33398 1.71745 7.33398H4.05078C4.41897 7.33398 4.71745 7.63246 4.71745 8.00065C4.71745 8.36884 4.41897 8.66732 4.05078 8.66732H1.71745C1.34926 8.66732 1.05078 8.36884 1.05078 8.00065Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7174 8.00065C12.7174 7.63246 13.0159 7.33398 13.3841 7.33398H14.3841C14.7523 7.33398 15.0508 7.63246 15.0508 8.00065C15.0508 8.36884 14.7523 8.66732 14.3841 8.66732H13.3841C13.0159 8.66732 12.7174 8.36884 12.7174 8.00065Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5794 11.3626C11.8397 11.1022 12.2618 11.1022 12.5222 11.3626L12.9936 11.834C13.2539 12.0943 13.2539 12.5164 12.9936 12.7768C12.7332 13.0371 12.3111 13.0371 12.0508 12.7768L11.5794 12.3054C11.319 12.045 11.319 11.6229 11.5794 11.3626Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1317 3.13977C13.392 3.40012 13.392 3.82223 13.1317 4.08258L12.1889 5.02539C11.9285 5.28574 11.5064 5.28574 11.246 5.02539C10.9857 4.76504 10.9857 4.34293 11.246 4.08258L12.1889 3.13977C12.4492 2.87942 12.8713 2.87942 13.1317 3.13977Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85552 10.3626C6.11587 10.6229 6.11587 11.045 5.85552 11.3054L3.9699 13.191C3.70955 13.4514 3.28744 13.4514 3.02709 13.191C2.76674 12.9307 2.76674 12.5085 3.02709 12.2482L4.91271 10.3626C5.17306 10.1022 5.59517 10.1022 5.85552 10.3626Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16516 3.0017C3.42551 2.74135 3.84762 2.74135 4.10797 3.0017L5.52219 4.41591C5.78254 4.67626 5.78254 5.09837 5.52219 5.35872C5.26184 5.61907 4.83973 5.61907 4.57938 5.35872L3.16516 3.94451C2.90481 3.68416 2.90481 3.26205 3.16516 3.0017Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading01);
export default __webpack_public_path__ + "static/media/loading-01.7f6e3356f5e1fbabe35f0b38ba05c3d0.svg";
export { ForwardRef as ReactComponent };